import React from 'react'
import { Flex, Typography } from 'antd'
import { BalanceStatisticBlock } from './widgets/balanceStatisticBlock'
import { ActiveBalances } from './widgets/activeBalances'
import { PassiveBalances } from './widgets/passiveBalances'
import { GeneralBalanceFilter } from './widgets/generalBalanceFilter'

export const BalanceSummaryPage = () => {
  return (
    <div className="d-flex flex-column gap-2">
      <Typography.Title level={1}>Financial statement</Typography.Title>
      <GeneralBalanceFilter />
      <BalanceStatisticBlock />
      <Flex gap={12}>
        <ActiveBalances />
        <PassiveBalances />
      </Flex>
    </div>
  )
}
